import { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Icon from "@mdi/react";
import { mdiClose, mdiStopCircleOutline, mdiVolumeHigh } from "@mdi/js";
import { UseManageData } from "../../../context/manageData";
import axios from "axios";
import baseUrl from "../../../util/baseUrl";
import { useTranslation } from "react-i18next";
import { IoCloseCircleOutline } from "react-icons/io5";
import Button from "../../../components/Button";

const EfficiencyModal = ({ open, setOpen, language }) => {
  const { stateData } = UseManageData();
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [audioObject, setAudioObject] = useState();
  const [snapshotData, setSnapshotData] = useState(null);
  const { t, i18n } = useTranslation();
  const [currentVehicle, setCurrentVehicle] = useState(null);

  const getText = (vehicleType, data) => {
    switch (vehicleType) {
      case "Vans":
        return `Vans, Keep your tire pressure between ${data.suv_FrontTire_pressure_recom}psi to ${data.suv_RearTire_pressure_recom}psi to save up to $ ${data.VAN_Tire_Pressure_Saving} in next 1000 miles per vehicle. Keep your speed between ${data.suv_lower_speed_limit} to ${data.suv_upper_speed_limit}mph to save up to $ ${data.VAN_Speeding_saving} per vehicle. Leaving vehicle Idle for more than ${data.suv_idletime_recom}mins, It may cost about $ ${data.VAN_Idling_Saving} per vehicle. Advice Drivers`;
      case "Sedans":
        return `Sedans, Keep your tire pressure between ${data.sedan_FrontTire_pressure_recom}psi to ${data.sedan_RearTire_pressure_recom}psi to save up to $ ${data.Sedan_Tire_Pressure_Saving} in next 1000 miles per vehicle. Keep your speed between ${data.sedan_lower_speed_limit} to ${data.sedan_upper_speed_limit}mph to save up to $ ${data.Sedan_Speeding_saving} per vehicle. Leaving vehicle Idle for more than ${data.sedan_idletime_recom}mins, It may cost about $ ${data.Sedan_Idling_Saving} per vehicle. Advice Drivers`;
      case "PickUp Trucks":
        return `PickUp Trucks, Keep your tire pressure between ${data.pickup_FrontTire_pressure_recom}psi to ${data.pickup_RealTire_pressure_recom}psi to save up to $ ${data.SUV_Tire_Pressure_Saving} in next 1000 miles per vehicle. Keep your speed between ${data.pickup_lower_speed_limit} to ${data.pickup_upper_speed_limit}mph to save up to $ ${data.SUV_Speeding_saving} per vehicle. Leaving vehicle Idle for more than ${data.pickup_idletime_recom}mins, It may cost about $ ${data.SUV_Idling_Saving} per vehicle. Advice Drivers`;
      default:
        return "";
    }
  };

  const speak = async (text, vehicleType) => {
    if (isSpeaking) {
      stopAudio();
    }
    setIsSpeaking(true);
    setCurrentVehicle(vehicleType);
    setSnapshotData(stateData);
    try {
      const response = await axios.get(
        `${baseUrl}/text_to_speech?text=${encodeURIComponent(
          text
        )}&language=${language}`,
        {
          responseType: "blob",
        }
      );
      const blob = new Blob([response.data], { type: "audio/mp3" });
      const blobUrl = URL.createObjectURL(blob);
      const audio = new Audio(blobUrl);
      audio.onended = () => {
        setIsSpeaking(false);
        setCurrentVehicle(null);
      };
      audio.play();
      setAudioObject(audio);
    } catch (err) {
      console.log("Error converting text to speech", err);
    }
  };
  const stopAudio = () => {
    if (audioObject) {
      audioObject.pause();
      audioObject.currentTime = 0;
      setIsSpeaking(false);
      setAudioObject(null);
      setCurrentVehicle(null);
    }
  };

  useEffect(() => {
    if (!open) {
      stopAudio();
    }
  }, [open]);

  const displayedData = isSpeaking ? snapshotData : stateData;

  if (!displayedData) {
    return null;
  }

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-[100]" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-[8px] bg-white dark:bg-[#222222] text-left shadow-xl transition-all sm:my-8 w-full sm:w-[50%] sm:p-[24px_24px_30px_24px] ">
                  <div>
                    <div className="flex justify-between items-center">
                      <div className="flex items-center gap-[13px]">
                        {/* <img src='/assets/icons/notification-bing.svg' alt="notification" /> */}

                        <img
                          src="/assets/icons/notification-bing-blue.svg"
                          alt="notification"
                        />

                        <div>
                          <h1 className="font-bold text-[20px] dark:text-white">
                            {t("Improve Now!")}
                          </h1>
                          <p className="text-[#9b9696] dark:text-[#E4232F]">
                            {t("134 devices need attention")}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className="flex gap-2 items-center">
                          <div className="flex items-center gap-[15px]">
                            {/* <div className='w-full flex justify-between items-center border border-[#F26538] rounded-md relative bg-light-pattern shadow-[0px_4px_6px_0px_rgba(242,101,56,0.10)]'>
                          <div className='absolute flex items-center justify-center -left-[10px] top-1/2 -translate-y-1/2 bg-alert-pattern w-5 h-5 rounded-full'>
                            <img src='/assets/icons/warning.svg' alt="warning" className='w-3' />
                          </div>
                          <div className='py-2 pl-6 pr-3 flex-grow text-dark text-sm'>{displayedData.VehiclesNeedAttention} Vehicle need attention now</div>
                          <button className='bg-alert-pattern rounded-md text-sm text-white p-[10px] -mr-px'>Take action</button>
                        </div> */}
                            <IoCloseCircleOutline
                              onClick={() => setOpen(false)}
                              className="cursor-pointer text-[30px] dark:text-white"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="flex mt-[30px] justify-between items-center">
                        <div className="flex items-center gap-[30px] w-full">
                          <div className="mb-[10px] bg-[#F1F5FA] rounded-full min-w-[50px] w-[50px] h-[50px] flex items-center justify-center">
                            <img
                              src="/assets/icons/popups/wifi-error.svg"
                              alt="33"
                              className="w-[30px] min-w-[30px] h-[30px]"
                            />
                          </div>
                          <div className="flex justify-between items-center w-full border-b border-b-[#f2efef] pb-[10px]">
                            <div>
                              <h1 className="font-normal text-[17px] text-[#000] dark:text-white">
                                {t(
                                  "Bandwidth is completely exhausted do not connect more devices"
                                )}
                              </h1>
                              {/* <p className="text-[#9b9696] my-[7px] dark:text-[#E4232F]">
                                {t("Investigate network performance!!")}
                              </p> */}
                            </div>

                            <Button>{t("Take Action")}</Button>
                          </div>
                        </div>
                      </div>
                      <div className="flex mt-[30px] justify-between items-center">
                        <div className="flex items-center gap-[30px] w-full">
                          <div className="mb-[10px] bg-[#F1F5FA] rounded-full min-w-[50px] w-[50px] h-[50px] flex items-center justify-center">
                            <img
                              src="/assets/icons/popups/disconnected.svg"
                              alt="239565"
                              className="w-[30px] min-w-[30px] h-[30px]"
                            />
                          </div>
                          <div className="flex justify-between items-center w-full border-b border-b-[#f2efef] pb-[10px]">
                            <div>
                              <h1 className="font-normal text-[17px] text-[#000] dark:text-white">
                                {t(
                                  "Reduce Devices disconnect 2 devices for better quality of experience"
                                )}
                              </h1>
                              {/* <p className="text-[#9b9696] my-[7px] dark:text-[#EBAE1B]">
                                {t("Advise on stability improvements!")}
                              </p> */}
                            </div>
                            <Button>{t("Take Action")}</Button>
                          </div>
                        </div>
                      </div>
                      <div className="flex mt-[30px] justify-between items-center">
                        <div className="flex items-center gap-[30px] w-full">
                          <div className="mb-[10px] bg-[#F1F5FA] rounded-full min-w-[50px] w-[50px] h-[50px] flex items-center justify-center">
                            <img
                              src="/assets/icons/popups/disconnected-wifi.svg"
                              alt="239566"
                              className="w-[30px] min-w-[30px] h-[30px]"
                            />
                          </div>
                          <div className="flex justify-between items-center w-full border-b border-b-[#f2efef] pb-[10px]">
                            <div>
                              <h1 className="font-normal text-[17px] text-[#000] dark:text-white">
                                {t(
                                  "Wi-Fi signal is being hindered clear the space around the gateway."
                                )}
                              </h1>
                              {/* <p className="text-[#9b9696] my-[7px] dark:text-[#EBAE1B]">
                                {t("Inform maintenance team!")}
                              </p> */}
                            </div>
                            <Button>{t("Take Action")}</Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};
export default EfficiencyModal;
